import { bindRequestLogic } from './utils'
import LanguageTypes from '../actionTypes/language'
import { languageAPI } from '../api'

const getLanguages = bindRequestLogic({
  clientFunc: languageAPI.getLanguages,
  type: LanguageTypes.GET_LANGUAGES_REQUEST,
  successType: LanguageTypes.GET_LANGUAGES_SUCCESS,
  failType: LanguageTypes.GET_LANGUAGES_FAILED,
  isQueryParam: true,
  modelName: 'languages'
})

const addLanguage = bindRequestLogic({
  clientFunc: languageAPI.addLanguage,
  type: LanguageTypes.ADD_LANGUAGE_REQUEST,
  successType: LanguageTypes.ADD_LANGUAGE_SUCCESS,
  failType: LanguageTypes.ADD_LANGUAGE_FAILED
})

const getLanguageDetail = bindRequestLogic({
  clientFunc: languageAPI.getLanguageDetail,
  type: LanguageTypes.GET_LANGUAGE_DETAIL_REQUEST,
  successType: LanguageTypes.GET_LANGUAGE_DETAIL_SUCCESS,
  failType: LanguageTypes.GET_LANGUAGE_DETAIL_FAILED,
  modelName: 'language'
})

const updateLanguage = bindRequestLogic({
  clientFunc: languageAPI.updateLanguage,
  type: LanguageTypes.UPDATE_LANGUAGE_REQUEST,
  successType: LanguageTypes.UPDATE_LANGUAGE_SUCCESS,
  failType: LanguageTypes.UPDATE_LANGUAGE_FAILED
})

const deleteLanguage = bindRequestLogic({
  clientFunc: languageAPI.deleteLanguage,
  type: LanguageTypes.DELETE_LANGUAGE_REQUEST,
  successType: LanguageTypes.DELETE_LANGUAGE_SUCCESS,
  failType: LanguageTypes.DELETE_LANGUAGE_FAILED
})

const addLanguageTranslation = bindRequestLogic({
  clientFunc: languageAPI.addLanguageTranslation,
  type: LanguageTypes.ADD_LANGUAGE_TRANSLATION_REQUEST,
  successType: LanguageTypes.ADD_LANGUAGE_TRANSLATION_SUCCESS,
  failType: LanguageTypes.ADD_LANGUAGE_TRANSLATION_FAILED
})

const updateLanguageTranslation = bindRequestLogic({
  clientFunc: languageAPI.updateLanguageTranslation,
  type: LanguageTypes.UPDATE_LANGUAGE_TRANSLATION_REQUEST,
  successType: LanguageTypes.UPDATE_LANGUAGE_TRANSLATION_SUCCESS,
  failType: LanguageTypes.UPDATE_LANGUAGE_TRANSLATION_FAILED
})

const deleteLanguageTranslation = bindRequestLogic({
  clientFunc: languageAPI.deleteLanguageTranslation,
  type: LanguageTypes.DELETE_LANGUAGE_TRANSLATION_REQUEST,
  successType: LanguageTypes.DELETE_LANGUAGE_TRANSLATION_SUCCESS,
  failType: LanguageTypes.DELETE_LANGUAGE_TRANSLATION_FAILED
})

export const getSystemLanguages = bindRequestLogic({
  clientFunc: languageAPI.getSystemLanguages,
  type: LanguageTypes.GET_SYSTEM_LANGUAGES_REQUEST,
  successType: LanguageTypes.GET_SYSTEM_LANGUAGES_SUCCESS,
  failType: LanguageTypes.GET_SYSTEM_LANGUAGES_FAILED,
  isQueryParam: true
})

export default [
  getLanguages,
  addLanguage,
  getLanguageDetail,
  updateLanguage,
  deleteLanguage,
  addLanguageTranslation,
  deleteLanguageTranslation,
  updateLanguageTranslation,
  getSystemLanguages
]
